<template>
  <li class="list-group-item">
    <span class="tag tag-default float-xs-right" :class="spanClass">{{value}}</span>
    {{title}}
  </li>
</template>

<script>
export default {
  name: "BalanceCardRow",
  props: {
    value: Number,
    title: String,
  },
  computed: {
    spanClass() {
      const val = Number(this.value) //Number(this.value.replace(" ", ""));
      switch (true) {
        case val < 100:
          return "bg-red bg-darken-2";
        case val < 500:
          return "bg-yellow bg-darken-3";
        case val < 1000:
          return "bg-warning bg-darken-3";
        case val <= 2000:
          return "bg-green bg-darken-1";
        case val > 2000:
          return "bg-purple bg-darken-1";
      }
      return "";
    },
  },
};
</script>